import { useUser } from '@trustpad/launchpad';
import {
  Contract,
  GenericContractSendMethod,
} from '@trustpad/launchpad/dist/types';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Web3 from 'web3';
import { DHTreasuryABI } from '~features/diamondHands/abi';
import { mapTokenAddressToPool } from '~features/diamondHands/utils';
import { debug } from '~utils';

let cache = {};

export type DHReward = {
  token: string;
  total: number;
  paid: number;
  remaining: number;
  userPaid: number;
};

/**
 * Returns the stats such as tokens, total rewards, user claimed rewards from all DH treasuries.
 * A treasury stores the list of tokens (per chain), the collected relinquished tokens and the amounts paid out to users.
 */
export function useDHTreasury() {
  const { account } = useUser();
  const [rewards, setRewards] = useState<DHReward[]>([]);
  const tokenPools = mapTokenAddressToPool(rewards.map?.((v) => v.token));

  useEffect(() => {
    axios.get('/api/dh/rewards', { params: { account } }).then(({ data }) => {
      debug('useDHTreasury.rewards', data);
      setRewards(data.rewards || []);
      cache[account] = data;
    });
  }, [account]);

  return {
    tokenPools,
    rewards: rewards || [],
  };
}

export function getDHTreasuryContract({
  web3,
  address,
}: {
  web3: Web3;
  address: string;
}) {
  if (!web3) return;
  return new web3.eth.Contract(DHTreasuryABI, address) as DHTreasuryContract;
}

export type DHTreasuryReward = {
  tokens: string[];
  amounts: string[];
  paid: string[];
  remaining: string[];
};

export type DHTreasuryUserReward = {
  tokens: string[];
  paid: number[];
};

export interface DHTreasuryContract extends Contract {
  methods: {
    getUserRewards(
      account: string,
    ): GenericContractSendMethod<DHTreasuryUserReward>;
    getRewards(): GenericContractSendMethod<DHTreasuryReward>;
    addRewards(token: string, amount: string): GenericContractSendMethod;
    transferReward(
      token: string,
      amount: string,
      to: string,
    ): GenericContractSendMethod;
  };
}
